import React, { useEffect, useRef, useState, useContext } from 'react'
import { makeStyles } from '@mui/styles'
import { Grid, Theme } from '@mui/material';
import "../css/receivefunds.css"
import {FirebaseContext} from "../../../context/firebase";


// APP POPUPS ARE POSITIONED IN Transaction history PAGE
const useStyles = makeStyles((theme: Theme)=>{
    return {
        navIcon: {
            color: '#999 !important',
            fontSize: '1.7rem !important',
            fontWeight: '900 !important'
        },
        logo: {
            transition: 'height 0.4s ease 0s, opacity 0.3s ease 0s',
            margin:'0 auto'
        },
        logoHolder: {
          width: '100%',
          display: 'flex',
          justifyContent:'center',
          alignItems: 'center'
        },
        paragraph: {
          lineHeight: 1.6,
          color: '#555',
          fontSize: '0.978rem',
          fontStyle: 'normal',
          textAlign: 'left',
          fontWeight: '400',
          marginBottom: '30px'
      },
      footer: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        padding: '1rem',
        [theme.breakpoints.down('md')]: {
          padding: '0rem',
        },
      },
      linkButton: {
        color: '#fff !important',
        backgroundColor: '#5d307f',
        borderColor: '#5d307f',
        marginLeft: '10px',
        display: 'inline-block',
        fontWeight: 400,
        textAlign: 'center',
        whiteSpace: 'nowrap',
        verticalAlign: 'middle',
        userSelect: 'none',
        border: '1px solid transparent',
        padding: '0.375rem 0.75rem',
        fontSize: '1rem',
        lineHeight: 1.5,
        borderRadius: '0.25rem',
        textDecoration: 'none',
        transition: 'all 0.15s ease-in-out',

        "&:hover": {
          color: '#000 !important',
          backgroundColor: '#e37927',
          borderColor: '#e37927',
        },

        [theme.breakpoints.down('sm')]: {
          marginLeft: '0',
          marginTop: '5px',
          display: 'block'
        },
      },
      asideInner: {
        padding: '1rem',
        width: '100%',
        height: '100%',

        [theme.breakpoints.down('md')]: {
          padding: '1rem',
        },
      }
    }
})


interface Props{
    handleBeneficiaryClose4: ()=> void
    transactionDetailsActiveItem: any
}

const TransactionDetailPopup: React.FC<Props> = ({handleBeneficiaryClose4, transactionDetailsActiveItem}) => {
    const { data, error, refresh } = useContext(FirebaseContext);

  const classes = useStyles()

  return (
    <div id='transaction-detail-popup' className='sidebar-wrapper-receive-funds'>
        
        <div className='sidebar-receive-funds-beneficiariesmodal-dialog modal-dialog-scrollable' style={{height: '100%'}}>
            <aside className='sidebar-transaction-recipte'>
                
            <div className='funds-beneficiaries-header'>
              <h6 className="funds-ben-header-h6" style={{fontSize: '20px'}}>Receipt</h6>
              <button type="button" className="btn-beneficiaries-funds close" onClick={handleBeneficiaryClose4}>×</button>
            </div>


            <div className='funds-beneficiaries-body'>
              <div style={{margin: '1rem 0'}}>
                <div style={{marginBottom: '3rem', height: '230px'}}>
                  <div style={{position: 'relative', overflow: 'hidden'}}>
                    

                    <div className="transaction-detail-th-summary px-sm-5 px-3">
                        <div className="transaction-detail-th-summary__info"><span>Reference ID</span><span className="text-capitalize">{transactionDetailsActiveItem.transactionRef}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Amount</span><span className="text-capitalize amount">${transactionDetailsActiveItem.amount}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Paid on</span><span className="text-capitalize">{transactionDetailsActiveItem.date}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Time</span><span className="text-capitalize">{transactionDetailsActiveItem.time}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Available Balance</span><span className="text-capitalize">${transactionDetailsActiveItem.balance}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Sender</span><span className="text-capitalize">{data.name}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Narration</span><span className="text-capitalize narration">{transactionDetailsActiveItem.description} </span></div>
                        <div className="transaction-detail-th-summary__info"><span>Method</span><span className="text-capitalize">{transactionDetailsActiveItem.method}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Status</span><span className="text-capitalize">{transactionDetailsActiveItem.status}</span></div>
                        <div className="transaction-detail-th-summary__info"><span>Location</span><span className="text-capitalize" style={{wordBreak: 'break-word'}}>{transactionDetailsActiveItem.location}</span></div>
                        <div className="transaction-detail-th-summary__info"></div>
                    </div>

                  </div>
                </div>
              </div>
            </div>





                
            </aside>
        </div>
    </div>
  )
}

export default TransactionDetailPopup
